import React, { useState, useMemo } from "react";
import { humanReadableDate } from "../../../../../app/utils";
import { Button } from "../../../../../components/RegularComponents";

const headers = [
    {
        key: "businessLicenceType",
        title: "Licence type",
        sort: (isAscending) => (a, b) => {
            const aStr = a.businessLicenceType
            const bStr = b.businessLicenceType
            return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
        },
    },
    {
        key: "action",
        title: "Licence action",
        sort: (isAscending) => (a, b) => {
            const aStr = a.action
            const bStr = b.action
            return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
        },
    },
    {
        key: "province",
        title: "Province",
        sort: (isAscending) => (a, b) => {
            const aStr = a.province
            const bStr = b.province
            return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
        },
    },
    {
        key: "suspensionDate",
        title: "Suspension date",
        format: (val) => humanReadableDate(val),
        sort: (isAscending) => (a, b) => {
            const aStr = humanReadableDate(a.suspensionDate)
            const bStr = humanReadableDate(b.suspensionDate)
            return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
        },
    },
]

export const LicenceSuspensionTable = (props) => {
    const { licenceSuspendedData, setCriminalHistoryItem } = props;

    const [sortingParameters, setSortingParameters] = useState({})

    const rows = useMemo(() => {
        if(!licenceSuspendedData) { return []}
        const header = headers.find(h => h.key === sortingParameters.key)
        if(!header) { return licenceSuspendedData }

        const newRows = licenceSuspendedData.sort(header.sort(sortingParameters.isAscending));
        return newRows

    }, [sortingParameters, licenceSuspendedData])

    const getSortIcon = (header) => {
        if (header.key !== sortingParameters?.key) {
            return <i style={{ color: "lightgray" }} className={`fa fa-2x fa-sort`} />
        }
        const activeClass = header.key === sortingParameters?.key ? "active" : ""
        const activeStyle = header.key === sortingParameters?.key ? "#0058a4" : "lightgray"
        const iconStr = sortingParameters?.isAscending ? "fa-sort-asc" : "fa-sort-desc"
        return <i style={{ color: activeStyle }} className={`fa fa-2x ${activeClass} ${iconStr}`} />
    }

    const headerClicked = (header) => () => {
        let modifiedSortingParams = { ...sortingParameters }

        if (header.key === modifiedSortingParams.key) {
            modifiedSortingParams.isAscending = !modifiedSortingParams.isAscending
        } else {
            modifiedSortingParams = { key: header.key, isAscending: false }
        }

        setSortingParameters(modifiedSortingParams)
    }

    return (
        <div style={{ marginTop: "1em" }}>
            <table>
                <thead>
                    <tr>
                        {headers.map((h) => (
                            <th key={h.key} onClick={headerClicked(h)}>
                                <div style={{
                                    display: "inline-flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    gap: "0.5rem",
                                    alignItems: "center",
                                    cursor: "arrow",
                                    borderRight: "1px solid lightgrey"
                                }}><span>{h.title}</span> <span style={{marginRight: "6px"}}>{getSortIcon(h)}</span></div>
                            </th>
                        ))}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((criminalHistoryItem, index) => (
                        <tr key={index}>
                            {headers.map((header, headerIndex) => {
                                const key = header.key;
                                const value = criminalHistoryItem[key]
                                const formattedValue = header.format ? header.format(value) : value;
                                return <td key={headerIndex}>{formattedValue}</td>
                            })}
                            <td>
                                <Button id={`licence-suspension-detail-${index}`}
                                    className={"licence-queue-review-readonly-button"}
                                    buttonType="regular_primary"
                                    text="Details"
                                    onClick={() => {
                                        // change to the details screens
                                        // console.log('yo')
                                        setCriminalHistoryItem(criminalHistoryItem)
                                    }} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    )
}
